const featuredSections = document.querySelectorAll(
  ".Section--featured-collections"
);

featuredSections.forEach((section) => {
  initFeaturedCollections(section);
});

function initFeaturedCollections(section) {
  const nav = section.querySelector(".Featured--nav");
  const collections = section.querySelectorAll(
    ".Featured--collection:not(.Layout--placeholder)"
  );
  let currentTab = collections[0];

  setActive(currentTab);

  const navButtons = nav.querySelectorAll(".Featured--button");
  let currentBtn = navButtons[0];

  let maxSize = 0;

  navButtons.forEach((btn) => {
    const btnSize = btn.offsetWidth;
    if (btnSize > maxSize) maxSize = btnSize;
  });
  nav.style.setProperty("--button-width", maxSize + "px");

  setActive(currentBtn);

  const navTriggers = nav.querySelectorAll(".Featured--tab");
  navTriggers[0].classList.add("Active");

  navTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      const tabId = trigger.dataset.tab;
      onTabChanged(tabId);

      navTriggers.forEach((trigger) => {
        trigger.classList.remove("Active");
      });
      trigger.classList.add("Active");
    });
  });

  function onTabChanged(tabId) {
    if (tabId === currentTab.dataset.tab) return;

    removeActive(currentTab);

    collections.forEach((collection) => {
      if (collection.dataset.tab === tabId) {
        currentTab = collection;
        setActive(collection);
      }
    });

    removeActive(currentBtn);

    navButtons.forEach((btn) => {
      if (btn.dataset.tab === tabId) {
        setActive(btn);
        currentBtn = btn;
        // nav.style.setProperty("--button-width", btn.offsetWidth + "px");
      }
    });
  }

  function setActive(collection) {
    collection.classList.add("Active");
    collection.classList.remove("LastActive");

    const productThumbnails = collection.querySelectorAll(".ProductThumbnail");
    productThumbnails.forEach((thumbnail) => {
      thumbnail.classList.add("Shown");
    });
  }

  function removeActive(collection) {
    collection.classList.add("LastActive");
    collection.classList.remove("Active");
    setTimeout(() => {
      collection.classList.remove("LastActive");
      const productThumbnails =
        collection.querySelectorAll(".ProductThumbnail");
      productThumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove("Shown");
      });
    }, 500);
  }
}
